const steps = [
  {
    n: "01",
    t: "Briefing",
    d: "Chiamata di 15 minuti per capire obiettivi, target e stile. Ti mando un preventivo entro 24h.",
  },
  {
    n: "02",
    t: "Riprese & Editing",
    d: "Con Sony a6400 giriamo in loco. Editing cinematico, color grading professionale, sound design curato.",
  },
  {
    n: "03",
    t: "Revisione",
    d: "Ricevi un link privato per commentare direttamente sul video. Fino a 2 revisioni incluse.",
  },
  {
    n: "04",
    t: "Consegna",
    d: "Video finali in tutti i formati che ti servono: verticale per social, orizzontale per YouTube/sito.",
  },
];

export default function Process() {
  return (
    <section id="processo" data-testid="process-section" className="py-24 sm:py-32">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4">
            <div className="overline mb-4">Come lavoriamo</div>
            <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tighter">
              Un processo
              <br />
              <span className="text-white/40">semplice, veloce, chiaro.</span>
            </h2>
            <p className="mt-6 text-white/60 leading-relaxed max-w-md">
              Nessuna sorpresa. Sai sempre in che fase siamo e quando riceverai il video finale.
            </p>
          </div>

          <div className="lg:col-span-8 divide-y divide-white/10 border-t border-b border-white/10">
            {steps.map((s) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="grid grid-cols-[80px_1fr] md:grid-cols-[120px_200px_1fr] gap-6 py-8 items-baseline"
              >
                <span className="font-display text-3xl text-gold">{s.n}</span>
                <h3 className="font-display text-xl md:text-2xl font-medium">{s.t}</h3>
                <p className="text-white/60 leading-relaxed col-span-2 md:col-span-1">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
